import FaqPage from '../Pages/FaqPage';
// import Home from '../Pages/HomePage';
import Home from '../Pages/V2/HomePage';
import NewDetailPage from '../Pages/NewsDetailPage';
import NewsPage from '../Pages/NewsPage';
import PartnerPage from '../Pages/PartnerPage';
import Profile from '../Pages/ProfilePage';
import Dashboard from '../Pages/DashboardPage';
import EditProfile from '../Pages/EditProfile';
import HowtousePage from '../Pages/HowtousePage';
import AckPage from '../Pages/AckPage';
import ForgotPassword from '../Pages/ForgotPasswordPage';
import ResetPasswordPage from '../Pages/ResetPasswordPage';
import LoginPage from '../Pages/V2/LoginPage';
import RegisterPage from '../Pages/V2/RegisterPage';
import SpecializedNews from '../Pages/V2/SpecializedNews';
import NewsCategory from '../Pages/V2/NewsCategory';
import DetailedNews from '../Pages/V2/DetailedNews';
import VideoNews from '../Pages/V2/VideoNews';
import UpdateClients from '../Pages/V2/UpdateClients';

const routes = [
  {
    path: '/',
    lable: 'home',
    menu: 'home',
    exact: true,
    main: (props) => <Home {...props} />,
  },
  {
    path: '/nen-tang-so/:name',
    lable: 'profile',
    menu: 'profile',
    exact: true,
    main: (props) => <Profile {...props} />,
  },
  {
    path: '/tin-tuc',
    lable: 'news',
    menu: 'news',
    exact: true,
    main: (props) => <NewsCategory {...props} />,
  },
  {
    path: '/chuyen-muc/:category_slug',
    lable: 'specialized news',
    menu: 'specialized news',
    exact: true,
    main: (props) => <SpecializedNews {...props} />,
  },
  {
    path: '/tin-tuc/:category_slug',
    lable: 'news',
    menu: 'news',
    exact: true,
    main: (props) => <NewsCategory {...props} />,
  },
  {
    path: '/tin-tuc/:category_slug/:name',
    lable: 'new-detail',
    menu: 'new-detail',
    exact: true,
    main: (props) => <DetailedNews {...props} />,
  },
  {
    path: '/tin-video/:category_slug/:name',
    lable: 'new-detail',
    menu: 'new-detail',
    exact: true,
    main: (props) => <VideoNews {...props} />,
  },
  {
    path: '/giai-dap-thac-mac',
    lable: 'faq',
    menu: 'faq',
    exact: true,
    main: (props) => <FaqPage {...props} />,
  },
  {
    path: '/huong-dan-su-dung',
    lable: 'howto',
    menu: 'howto',
    exact: true,
    main: (props) => <HowtousePage {...props} />,
  },
  {
    path: '/quyet-dinh-so-377-cua-bo-truong-bo-thong-tin-truyen-thong',
    lable: 'decision',
    menu: 'decision',
    exact: true,
    main: (props) => <AckPage {...props} />,
  },
  {
    path: '/nen-tang-so',
    lable: 'partner',
    menu: 'partner',
    exact: true,
    main: (props) => <PartnerPage {...props} />,
  },
  {
    path: '/bang-dieu-khien',
    lable: 'dashboard',
    menu: 'dashboard',
    exact: true,
    main: (props) => <Dashboard {...props} />,
  },
  {
    path: '/bang-dieu-khien/cap-nhat-thong-tin',
    lable: 'profile',
    menu: 'profile',
    exact: true,
    main: (props) => <EditProfile {...props} />,
  },
  {
    path: '/bang-dieu-khien/bao-cao-chuyen-doi-so',
    lable: 'client',
    menu: 'client',
    exact: true,
    main: (props) => <UpdateClients {...props} />,
  },
  {
    path: '/quen-mat-khau',
    lable: 'forgotpassword',
    menu: 'forgotpassword',
    exact: true,
    main: (props) => <ForgotPassword {...props} />,
  },
  {
    path: '/thay-doi-mat-khau',
    lable: 'forgotpassword',
    menu: 'forgotpassword',
    exact: true,
    main: (props) => <ResetPasswordPage {...props} />,
  },
  {
    path: '/dang-nhap',
    lable: 'login',
    menu: 'login',
    exact: true,
    main: (props) => <LoginPage {...props} />,
  },
  {
    path: '/dang-ky-tai-khoan',
    lable: 'login',
    menu: 'login',
    exact: true,
    main: (props) => <RegisterPage {...props} />,
  },
];

export default routes;
